export default "__VITE_ASSET__tEy4gHke__"